// FRAMEWORK
import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import { useInfiniteHits, useSearchBox } from 'react-instantsearch'
import ProductCardMini from '../components/product-card-mini'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import AppContext from '../context/app'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'

export default function Results() {
    const { searchClicked, setSearchClicked } = useContext(AppContext)
    const allProduct = useGetAllBuilderProducts()
    const defaultResults = ['ARSP2', 'ARJR1', 'ARDL2']

    // https://www.algolia.com/doc/api-reference/widgets/infinite-hits/react/#hook-usage
    const { hits, results } = useInfiniteHits()
    const { clear } = useSearchBox()
    
    if (!results.query && !searchClicked) return
    return (
        <Container fluid
            className='d-flex pt-md-5 pt-3 position-absolute'
            style={{
                left: 0,
                top: '100%',
                height: '100vh',
                background: `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.90) 50.07%, rgba(0, 0, 0, 0.50) 100%)`,
            }}
        >
            <Container>
                {/* SUGGESTED PRODUCTS LINE */}
                <p className='text-secondary ff-primary fw-bold'>
                    SUGGESTED PRODUCTS
                </p>

                {/* 3 MINI PRODUCT CARDS */}
                <div className='d-grid gap-4' css={{
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    '@media(max-width: 576px)': { gridTemplateColumns: '1fr' },
                }}>
                    {
                        results?.query ?
                            hits.slice(0, 3).map(hit => {
                                return <ProductCardMini product={hit} onClick={clear} />
                            })
                            :
                            defaultResults.map(defaultResultSku => {
                                const product = allProduct.find(({ sku }) => defaultResultSku === sku)
                                return <ProductCardMini product={product} onClick={clear} />
                            })
                    }
                </div>

                {/* VIEW ALL RESULTS BUTTON */}
                <p className='flex-center gap-3 mb-0 mt-md-4'>
                    <Button
                        style={{ fontSize: 18, width: 312 }}
                        className="inline-flex-center gap-1 bg-transparent ff-primary text-white text-uppercase border border-white border-2"
                        onClick={() => {
                            clear()
                            setSearchClicked(false)
                        }}
                        title='Press (esc) to close'
                    >
                        <img src='/svg/x-close-icon-white.svg' alt='' height={24} />
                        CLOSE SEARCH
                    </Button>
                    <Button
                        style={{ fontSize: 18, width: 312 }}
                        className="d-inline-block bg-primary ff-primary text-uppercase border border-primary border-2"
                        onClick={() => {
                            navigate('/search', { state: results })
                            clear()
                            setSearchClicked(false)
                        }}
                    >
                        VIEW ALL SEARCH RESULTS ({results.nbHits})
                    </Button>
                </p>
            </Container>
        </Container>
    )
}
